// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2d1DM","unreadBadge":"styles_unreadBadge__3FxUz","modalContent":"styles_modalContent__t8pK5","modal":"styles_modal__2qNJi"};